import Model from 'braindamage/model'
import DodoableSchema from 'generated/schemas/dodoable'

class Dodoable extends Model {
  static schema = DodoableSchema
  static modelName = 'Dodoable'

  // Fill-in your attribute overrides
  static attributesDefinitions() {
    return {
      children: {
        name: 'children',
        apiName: 'children',
        camelName: 'children',
        underscoreName: 'children',
        type: 'has_many',
        model: 'Dodoable',
        default: []
      }
    }
  }
}

export default Dodoable.define()
